// Bilingual content for ERA Group. Default language: EN.

export const LOGOS = {
  group:
    "https://customer-assets.emergentagent.com/job_eaa393f3-a77a-412a-960e-793befc12696/artifacts/phpe0ab1_Logo%20Era%20Kualitas%20Group.png",
  eraSolution:
    "https://customer-assets.emergentagent.com/job_eaa393f3-a77a-412a-960e-793befc12696/artifacts/k0hixejl_Logo%20Era.png",
  sistemManajemen:
    "https://customer-assets.emergentagent.com/job_eaa393f3-a77a-412a-960e-793befc12696/artifacts/znkdoq24_SM%20Fix.png",
  manpowerSys:
    "https://customer-assets.emergentagent.com/job_era-hub/artifacts/osv86j1s_Logo%20ManpowerSys.png",
};

export const BRAND = {
  name: "ERA Group",
  fullName: "ERA Kualitas Group",
  email: "info@eragroup.co.id",
  phone: "+62 821-2883-8826",
  phoneDigits: "6282128838826",
  address:
    "Jl. Ruko Sentra Bisnis 1, RSA 1 No.56, Grand Galaxy City, Kota Bekasi, Jawa Barat 17147",
  socials: {
    linkedin: "https://linkedin.com",
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
  },
};

export const BUSINESS_UNITS = [
  {
    id: "era-solution",
    name: "Era Solution",
    logo: LOGOS.eraSolution,
    website: "https://erasolution.co.id",
    accent: "navy",
    services: {
      en: ["Consulting", "IT Solutions", "Outsourcing"],
      id: ["Konsultasi", "Solusi IT", "Outsourcing"],
    },
    description: {
      en: "Business consulting, IT solutions, and outsourcing services that help organizations improve operational performance.",
      id: "Layanan konsultasi bisnis, solusi IT, dan outsourcing untuk membantu organisasi meningkatkan performa operasional.",
    },
  },
  {
    id: "sistem-manajemen",
    name: "Sistem Manajemen Indonesia",
    logo: LOGOS.sistemManajemen,
    website: "https://sistemmanajemen.id",
    accent: "gold",
    services: {
      en: ["Training", "Certification", "ISO Consulting"],
      id: ["Pelatihan", "Sertifikasi", "Konsultasi ISO"],
    },
    description: {
      en: "Professional training, certification, and ISO consulting to help organizations achieve sustainable excellence.",
      id: "Pelatihan profesional, sertifikasi, dan konsultasi ISO untuk membantu organisasi mencapai keunggulan berkelanjutan.",
    },
  },
  {
    id: "manpower-sys",
    name: "ManpowerSys",
    logo: LOGOS.manpowerSys,
    website: "#",
    accent: "teal",
    services: {
      en: ["Recruitment Platform", "Candidate Management", "P3MI Digital System"],
      id: ["Platform Rekrutmen", "Manajemen Kandidat", "Sistem Digital P3MI"],
    },
    description: {
      en: "A digital platform helping P3MI companies manage recruitment and candidate processes more efficiently.",
      id: "Platform digital untuk membantu perusahaan P3MI mengelola proses rekrutmen dan kandidat secara lebih efisien.",
    },
  },
];

export const INDUSTRIES = [
  { key: "manufacturing", icon: "Factory" },
  { key: "construction", icon: "HardHat" },
  { key: "healthcare", icon: "Stethoscope" },
  { key: "food", icon: "UtensilsCrossed" },
  { key: "education", icon: "GraduationCap" },
  { key: "government", icon: "Landmark" },
  { key: "energy", icon: "Zap" },
  { key: "mining", icon: "Mountain" },
  { key: "automotive", icon: "Car" },
];

export const WHY_ITEMS = [
  { key: "integrated", icon: "Layers" },
  { key: "experts", icon: "Users" },
  { key: "trusted", icon: "ShieldCheck" },
  { key: "coverage", icon: "Globe2" },
  { key: "innovation", icon: "Sparkles" },
  { key: "partnership", icon: "Handshake" },
];

export const MISSION_ITEMS = [
  { key: "expertise", icon: "Compass" },
  { key: "innovation", icon: "Lightbulb" },
  { key: "partnerships", icon: "Handshake" },
  { key: "growth", icon: "TrendingUp" },
];

export const VALUES = [
  { key: "integrity", icon: "ShieldCheck" },
  { key: "innovation", icon: "Sparkles" },
  { key: "collaboration", icon: "Users" },
  { key: "excellence", icon: "Award" },
];

export const STATS = [
  { key: "clients", value: "150+" },
  { key: "projects", value: "300+" },
  { key: "units", value: "3" },
  { key: "years", value: "10+" },
];
